


























import mixins from 'vue-typed-mixins';
import NotificationForm from '@/components/notification/NotificationForm.vue';
import NotificationUtils, { Notification } from '@/utils/NotificationUtils';
export default mixins().extend({
  components: {
    NotificationForm,
  },

  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },
  },

  data(): {
    item?: Partial<Notification>;
  } {
    return {
      item: undefined,
    };
  },

  async mounted() {
    try {
      if (this.id) {
        this.item = await NotificationUtils.api.get(this.id);
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    async save() {
      if (this.item) {
        try {
          this.$alert.hide('save');
          this.item = await NotificationUtils.api.update(this.item);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.item?.name],
            }),
          });
        } catch (error) {
          this.$alert.show('save', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      }
    },

    async remove() {
      await this.$confirm(
        this.$i18n
          .t('validation.confirmation.delete', [this.item?.name])
          .toString(),
        async () => {
          try {
            this.$alert.hide('remove');
            await NotificationUtils.api.remove(this.item?.id as number);
            await this.$router.push({ name: 'notification' });
            this.$toast.push({
              type: 'success',
              text: this.$languageobj('validation.success.delete', {
                values: [this.item?.name],
              }),
            });
          } catch (error) {
            this.$alert.show('remove', {
              type: 'error',
              messages: this.$handleAPIError(error),
            });
          }
        }
      );
    },

    async publish() {
      await this.$confirm(
        this.$i18n.tc('page.notification.edit.confirmPublish'),
        async () => {
          try {
            this.$alert.hide('publish');
            await NotificationUtils.api.publish(this.item?.id as number);
            this.$toast.push({
              type: 'success',
              text: this.$languageobj('page.notification.validate.publish'),
            });
          } catch (error) {
            this.$alert.show('publish', {
              type: 'error',
              messages: this.$handleAPIError(error),
            });
          }
        }
      );
    },
  },
});
